import React, {useState, useEffect, useContext} from 'react';
import {Card, CardHeader, CardBody, Input, Table} from 'reactstrap';
import Loader from 'components/Loader';
import PaginationWrapper from 'components/PaginationWrapper';
import {getFacebookAccountList} from 'utils/api';
import Account from './Account';
import {connect} from 'react-redux';
import {logout} from 'redux/modules/auth/action';
import {toast} from 'react-toastify';
import sortAlphabetically from 'helpers/sortAlphabetically';
import moment from 'moment';
import {sortByValue} from 'helpers/sortByValue';
import SortableTableHeader from 'components/SortableTableHeader';
import {ErrorContext} from 'contexts/ErrorContext';


const FeedsPage = () => {
    const {handleErrors} = useContext(ErrorContext);

    const [searchValue, setSearchValue] = useState('');
    const [fullAccountsList, setFullAccountsList] = useState(null);
    const [visibleList, setVisibleList] = useState(null);
    const [newFeed, setNewFeed] = useState(false);
    const [activeSortProperty, setActiveSortProperty] = useState('email');
    const [activeSortDirection, setActiveSortDirection] = useState('asc');
    const [fetchingData, setFetchingData] = useState(true);
    const [numberOfUsedLimit, setNumberOfUsedLimit] = useState(0);
    const [numberOfLimit, setNumberOfLimit] = useState(0);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [activeMobileSortSelection, setActiveMobileSortSelection] = useState('email-asc');

    useEffect(() => {
        getAccountsList();
    }, []);

    useEffect(() => {
        if(fullAccountsList && visibleList) {
            let newArr = sortByValue(fullAccountsList, activeSortProperty, activeSortDirection);
            if(searchValue && searchValue.length > 0) {
                let arrFilteredBySearchValue = newArr.filter(item => {
                    return item.name.toLowerCase().includes(searchValue.toLowerCase());
                });
                setVisibleList(arrFilteredBySearchValue);
                setCurrentPageNumber(1);
            } else {
                setVisibleList(newArr);
                setCurrentPageNumber(1);
            }
        }
    }, [activeSortProperty, activeSortDirection, searchValue]);

    const getAccountsList = async() => {
        try {
            !fetchingData && setFetchingData(true);
            let accountsData = await getFacebookAccountList();
            accountsData.content.result.forEach(item => {
                if(item.name === null) item.name = '';
            });
            let initialList = sortAlphabetically(accountsData.content.result, 'email');
            setFullAccountsList(initialList);
            setVisibleList(initialList);
            setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors();
            setFetchingData(false);
        }
    };

    const updatePermissionsForUser = (newPermissions, userId) => {
        visibleList.find(item => item.id === userId).permissions = newPermissions;
    };

    const handlePaginationClick = (pageNumber) => {
        setCurrentPageNumber(pageNumber.selected + 1);
    };

    const handleSortSelect = (sortValue) => {
        if(activeSortProperty === sortValue) {
            setActiveSortDirection(activeSortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setActiveSortProperty(sortValue);
            setActiveSortDirection('asc');
        }
    };

    const handleMobileSortSelect = (sortSelection) => {
        let splitArr = sortSelection.split('-')
        if(splitArr.length === 2) {
            setActiveSortProperty(splitArr[0])
            setActiveSortDirection(splitArr[1])
        }
        setActiveMobileSortSelection(sortSelection)
    };

    return (
        <div className="wrapper d-flex align-items-center mt-3 flex-column">
            <Card className="w-100">
                <CardHeader>
                    <h1 className="mb-0" style={{textAlign: 'center'}}>FB Accounts</h1>
                </CardHeader>
                {visibleList === null ? (
                    <div style={{padding: '3rem 2rem'}}>
                        <Loader small text="Fetching account data"/>
                    </div>
                ) : (
                    <CardBody onClick={() => newFeed !== false && setNewFeed(false)}>
                        <div className="feeds-container_input">
                            {fullAccountsList !== null && fullAccountsList.length > 0 && (
                                <div className="feeds-container-wrapper">
                                    <Input
                                        style={{height: '35px'}}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        value={searchValue}
                                        placeholder="Search by email"
                                        type="text"
                                        className="searchInput"
                                    />
                                    {!searchValue ? (
                                        <i
                                            style={{position: 'absolute', top: '28%', bottom: '10.5px', right: '11px'}}
                                            className="fa fa-search search-container_icon"
                                        />
                                    ) : (
                                        <i
                                            style={{
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                top: '28%',
                                                bottom: '10.5px',
                                                right: '11px',
                                            }}
                                            onClick={() => setSearchValue('')}
                                            className="fa fa-times-circle search-container_icon"
                                        />
                                    )}
                                </div>
                            )}
                            {/*<div>*/}
                            {/*    {`Limit used ${numberOfUsedLimit} of ${numberOfLimit}`}*/}
                            {/*</div>*/}
                        </div>
                        {fullAccountsList && fullAccountsList.length > 0 && (
                            <div className="feeds_sortBy">
                                <span>Sort by</span>
                                <Input onChange={(e) => handleMobileSortSelect(e.target.value)} type="select"
                                       value={activeMobileSortSelection}>
                                    <option value="email-asc">Email (A to Z)</option>
                                    <option value="email-desc">Email (Z to A)</option>
                                    <option value="name-asc">Name (A to Z)</option>
                                    <option value="name-desc">Name (Z to A)</option>
                                    <option value="isActive-desc">Active (Yes first)</option>
                                    <option value="isActive-asc">Active (No first)</option>
                                    {/*<option value="public">Public (Yes first)</option>*/}
                                    {/*<option value="publicDescending">Public (No first)</option>*/}
                                    <option value="accessTokenExperienceData-desc">Expired (New first)</option>
                                    <option value="accessTokenExperienceData-asc">Expired (Old first)</option>
                                    {/*<option value="limit">Hourly Limit (1 to 9)</option>*/}
                                    {/*<option value="limitDescending">Hourly Limit (9 to 1)</option>*/}
                                </Input>
                            </div>
                        )}
                        <div className="table mt-3">
                            {fullAccountsList && fullAccountsList.length > 0 ? (
                                <Table style={{color: '#314784'}} responsive>
                                    <thead className="hidden">
                                    <tr>
                                        <SortableTableHeader
                                            name="Email"
                                            value="email"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('email')}
                                        />
                                        <SortableTableHeader
                                            name="Name"
                                            value="name"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('name')}
                                        />
                                        <SortableTableHeader
                                            name="Active"
                                            value="isActive"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('isActive')}
                                        />
                                        <SortableTableHeader
                                            name="Expired At"
                                            value="accessTokenExperienceData"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('accessTokenExperienceData')}
                                        />
                                        {/*<th onClick={() => handleSortTypeChange('public')} style={{cursor: 'pointer'}}>*/}
                                        {/*    <div style={{border: 'none'}} className="d-flex align-items-center">*/}
                                        {/*        <span className="mr-1">Public</span>*/}
                                        {/*        <i className={*/}
                                        {/*            activeSort === 'public'*/}
                                        {/*                ? 'fas fa-sort-numeric-down'*/}
                                        {/*                : activeSort === 'publicDescending'*/}
                                        {/*                ? 'fas fa-sort-numeric-up'*/}
                                        {/*                : 'fas fa-sort'*/}
                                        {/*        }/>*/}
                                        {/*    </div>*/}
                                        {/*</th>*/}
                                        {/*<th onClick={() => handleSortTypeChange('expired')}*/}
                                        {/*    style={{cursor: 'pointer', minWidth: '160px'}}>*/}
                                        {/*    <div style={{border: 'none'}} className="d-flex align-items-center">*/}
                                        {/*        <span className="mr-1">Expired at</span>*/}
                                        {/*        <i className={*/}
                                        {/*            activeSort === 'expired'*/}
                                        {/*                ? 'fas fa-sort-numeric-down'*/}
                                        {/*                : activeSort === 'expiredDescending'*/}
                                        {/*                ? 'fas fa-sort-numeric-up'*/}
                                        {/*                : 'fas fa-sort'*/}
                                        {/*        }/>*/}
                                        {/*    </div>*/}
                                        {/*</th>*/}
                                        {/*<th onClick = {() => handleSortTypeChange('limit')} style={{ cursor: 'pointer', minWidth: '160px' }}>*/}
                                        {/*    <div style={{ border: 'none' }} className="d-flex align-items-center">*/}
                                        {/*        <span className="mr-1">Hourly Limit</span>*/}
                                        {/*        <i className={*/}
                                        {/*            activeSort === 'limit' */}
                                        {/*                ? 'fas fa-sort-numeric-down'*/}
                                        {/*                : activeSort === 'limitDescending' */}
                                        {/*                    ? 'fas fa-sort-numeric-up'*/}
                                        {/*                    : 'fas fa-sort' */}
                                        {/*        }/>*/}
                                        {/*    </div>*/}
                                        {/*</th>*/}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {fetchingData ? (
                                        <tr>
                                            <td className="mt-5"><Loader/></td>
                                        </tr>
                                    ) : (
                                        <React.Fragment>
                                            {visibleList && visibleList.length > 0 ? (
                                                visibleList.slice((currentPageNumber - 1) * 50, currentPageNumber * 50).map((item, index) => (
                                                    <Account
                                                        newFeeds={newFeed}
                                                        key={index}
                                                        item={item}
                                                        updatePermissionsForUser={updatePermissionsForUser}
                                                    />
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="mt-5">No matching results</td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    )}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="mt-5">No accounts found</p>
                            )}
                        </div>
                        {visibleList && visibleList.length > 50 && (
                            <PaginationWrapper
                                totalPages={Math.ceil(visibleList.length / 50)}
                                handlePageClick={handlePaginationClick}
                                // forcePage={paginationCurrentPageNumber - 1}
                            />
                        )}
                    </CardBody>
                )}
            </Card>
        </div>
    );
};

export default connect(
    null,
    {logout},
)(FeedsPage);
